import gql from 'graphql-tag'
import {
	media as mediaFragment
} from './fragments'

export const media = gql`
mutation updateMedia_Main($id: ID!, $fields: MediaFields!) {
	cashAssist {
		updateMedia(id: $id, fields: $fields) {
	    id
	    mod_ver
	    ...mediamain
	  }
	}
}
${mediaFragment}`

export const cashRegisters = gql`
mutation updateMedia_cashRegisters($id: ID! $fields: MediaFields!) {
	cashAssist {
	  updateMedia(id: $id, fields: $fields) {
	    id
	    mod_ver
	    cashRegisterId
	  }
	}
}
`

export default {
	media,
	cashRegisters
}
